import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import typeOfContract from '../../../constants/typeOfContract';
import { calculateServicesTotalCost } from './Services/reportServices';
import TotalCost from "../../../images/icons/total-cost.svg";

// Functional component
function ReportServicesTotalCost(props) {
  const [totalCost, setTotalCost] = useState(0);
  const reportingServices = useSelector((state) => state.reportingServices);
  const { forex } = useSelector((state) => state.forex);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const trackReport = props.trackReport;
  const projectCost = props.projectCost;


  var currencies = "USD";
  if (props.filteredCurrencies && props.filteredCurrencies.length === 1) {
    currencies = props.filteredCurrencies[0];
  } else {
    currencies = settings.currency;
  }

  useEffect(() => {
    const totalCostClient = calculateServicesTotalCost(trackReport, projectCost, reportingServices, currencies, forex, typeOfContract);
    setTotalCost(totalCostClient);
  }, [reportingServices, forex, settings.currency, projectCost, trackReport]);
  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">
            Total Cost

          </div>
          <div className="overview-icon">
            <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_2951_123)">
                <circle cx="24.5" cy="24.5" r="20.5" fill="white" />
              </g>
              <path d="M18.5 20C17.673 20 17 20.673 17 21.5V22.5C17 23.327 17.673 24 18.5 24H23.5C24.327 24 25 23.327 25 22.5V21.5C25 20.673 24.327 20 23.5 20H18.5ZM24 21.5V22.5C24 22.775 23.775 23 23.5 23H18.5C18.225 23 18 22.775 18 22.5V21.5C18 21.225 18.225 21 18.5 21H23.5C23.775 21 24 21.225 24 21.5ZM24 26.5C24 26.776 23.776 27 23.5 27H22.5C22.224 27 22 26.776 22 26.5C22 26.224 22.224 26 22.5 26H23.5C23.776 26 24 26.224 24 26.5ZM24 29.5C24 29.776 23.776 30 23.5 30H22.5C22.224 30 22 29.776 22 29.5C22 29.224 22.224 29 22.5 29H23.5C23.776 29 24 29.224 24 29.5ZM20 26.5C20 26.776 19.776 27 19.5 27H18.5C18.224 27 18 26.776 18 26.5C18 26.224 18.224 26 18.5 26H19.5C19.776 26 20 26.224 20 26.5ZM20 29.5C20 29.776 19.776 30 19.5 30H18.5C18.224 30 18 29.776 18 29.5C18 29.224 18.224 29 18.5 29H19.5C19.776 29 20 29.224 20 29.5ZM24 32.5C24 32.776 23.776 33 23.5 33H22.5C22.224 33 22 32.776 22 32.5C22 32.224 22.224 32 22.5 32H23.5C23.776 32 24 32.224 24 32.5ZM20 32.5C20 32.776 19.776 33 19.5 33H18.5C18.224 33 18 32.776 18 32.5C18 32.224 18.224 32 18.5 32H19.5C19.776 32 20 32.224 20 32.5ZM31.487 12H21.5C18.468 12 16 14.468 16 17.5C16 17.518 16.008 17.533 16.01 17.551C14.815 18.243 14 19.522 14 21V32C14 34.206 15.794 36 18 36H24C26.206 36 28 34.206 28 32V21C28 19.547 27.214 18.286 26.053 17.585C26.503 14.929 28.788 13 31.487 13C34.527 13 37 15.473 37 18.513V27.51L34.964 26.009C34.793 25.881 34.559 25.878 34.382 26.001L31.833 27.772L30.785 27.043C30.559 26.887 30.247 26.94 30.09 27.168C29.932 27.395 29.987 27.706 30.215 27.863L31.548 28.791C31.718 28.91 31.946 28.91 32.118 28.791L34.658 27.025L37.203 28.901C37.291 28.965 37.395 28.999 37.5 28.999C37.577 28.999 37.654 28.981 37.726 28.945C37.894 28.86 38 28.687 38 28.499V18.513C38 14.922 35.078 12 31.487 12ZM27 21V32C27 33.654 25.654 35 24 35H18C16.346 35 15 33.654 15 32V21C15 19.346 16.346 18 18 18H24C25.654 18 27 19.346 27 21ZM25.129 17.182C24.769 17.075 24.395 17 24 17H18C17.666 17 17.347 17.053 17.037 17.13C17.229 14.824 19.145 13 21.5 13H28.035C26.571 13.915 25.5 15.397 25.129 17.182Z" fill="#6A7988" stroke="#6A7988" stroke-width="0.2" />
              <defs>
                <filter id="filter0_d_2951_123" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2951_123" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2951_123" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>

        <div className="overview-rice">
          {totalCost ? `${new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencies,
          }).format(totalCost)}` : `${new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencies,
          }).format(0)}`}
        </div>
      </div>

    </div>
  );
}

export default ReportServicesTotalCost;
